import { Pipe, PipeTransform } from '@angular/core';
import { ContextService } from '@apply4u/services/context-service';
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Pipe({
  name: 'highlight',
  standalone:true
})
export class HighlightPipe implements PipeTransform {
  constructor(private contextService: ContextService) {
  }

  transform(value: any, args?: string, disableForMobile: boolean = false): any {
    if (IsNullOrEmpty(args) || this.contextService.IsBrowser == false || !this.contextService.IsClientSideLoading) return value;

    args = args.replace(/[(){}\[\]]/g, "");
    args = args.replace(/[\/\\()$~%.':*?<>{}]/g, " ");
    //args = args.replace(/[\/\\()$~%.'":*?<>{}]/g, " ");
    // args = args.replace(/[”]/g, "\"");
    // args = args.replace(/[“]/g, "\"");
    args = this.escapeRegExp(args).trim();

    let wordsToHighLight: string[] = [];

    let splittedByNot: string[] = args.toLowerCase().split('not');

    if (IsAny(splittedByNot)) {
      splittedByNot.forEach(w => {
        if (IsNotNullOrEmpty(w)) {
          let splittedByAnd = w.toLocaleLowerCase().split(' and ');

          if (IsAny(splittedByAnd)) {
            splittedByAnd.forEach(splittedByAndWord => {
              if (IsNotNullOrEmpty(splittedByAndWord) && splittedByAndWord.trim() != '') {
                let splittedByOr = splittedByAndWord.split(' or ');

                if (IsAny(splittedByOr)) {
                  splittedByOr.forEach(splittedByOrWord => {
                    if (IsNotNullOrEmpty(splittedByOrWord) && splittedByOrWord.trim() != '') {
                      if (splittedByOrWord.toLocaleLowerCase().trim().startsWith('"') && splittedByOrWord.toLocaleLowerCase().trim().endsWith('"')) {
                        splittedByOrWord = splittedByOrWord.replace(/["]/g, "");

                        if (splittedByOrWord.trim() != '') {
                          wordsToHighLight.push(splittedByOrWord.trim());
                        }
                      }
                      else {
                        let splittedBySpaceWords = splittedByOrWord.trim().split(' ');

                        if (IsAny(splittedBySpaceWords)) {
                          splittedBySpaceWords.forEach(splittedBySpaceWord => {
                            if (IsNotNullOrEmpty(splittedBySpaceWord) && splittedBySpaceWord.trim() != '') {
                              splittedBySpaceWord = splittedBySpaceWord.trim();

                              if (splittedBySpaceWord != '') {
                                wordsToHighLight.push(splittedBySpaceWord);
                              }
                            }
                          });
                        }
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });
    }

    if (IsAny(wordsToHighLight)) {
      wordsToHighLight = wordsToHighLight.sort(m => m.length);

      let arrangedWordsInDecending: string[] = [];

      for (let i = (wordsToHighLight.length - 1); i >= 0; i--) {
        arrangedWordsInDecending.push(wordsToHighLight[i]);
      }

      let classwords = arrangedWordsInDecending.filter(m => m.trim() == 'class');

      if (IsAny(classwords)) {
        classwords.forEach(element => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(element), 1);
        });
      }

      let wordHigh = arrangedWordsInDecending.filter(res => res.trim() == 'high');
      
      if (IsAny(wordHigh)) {
        wordHigh.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      let wordLight = arrangedWordsInDecending.filter(res => res.trim() == 'light');

      if (IsAny(wordLight)) {
        wordLight.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      let wordHighlight = arrangedWordsInDecending.filter(res => res.trim() == 'highlight');

      if (IsAny(wordHighlight)) {
        wordHighlight.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      let wordLighttext = arrangedWordsInDecending.filter(res => res.trim() == 'lighttext');

      if (IsAny(wordLighttext)) {
        wordLighttext.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      let wordHighlighttext = arrangedWordsInDecending.filter(res => res.trim() == 'highlighttext');

      if (IsAny(wordHighlighttext)) {
        wordHighlighttext.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      let wordText = arrangedWordsInDecending.filter(res => res.trim() == 'text');

      if (IsAny(wordText)) {
        wordText.forEach(ele => {
          arrangedWordsInDecending.splice(arrangedWordsInDecending.indexOf(ele), 1);
        });
      }

      arrangedWordsInDecending.forEach(word => {
        word = word.replace(',', '').trim();

        let re = new RegExp('\\b' + word + '\\b', 'gi');
        let match: any;

        if (IsNotNull(value)) {
          match = value.match(re);
        }

        if (!match) {
          return value;
        } else {
          value = value.replace(re, '<span class="highlighttext">' + match[0] + '</span>');
        }
      });

    }

    return value;
  }

  escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

}
